import React from 'react';
import { Container, SectionHeader, Card } from '../ui';
import { FEATURES } from '../../data/marketing';

// "Everything in one platform" feature grid.
const FeatureGrid = () => (
  <section id="features" className="bg-white py-16 sm:py-24 scroll-mt-16">
    <Container>
      <SectionHeader
        align="center"
        eyebrow="Everything in one platform"
        title="From Friday night lights to opening night"
        subtitle="Athletics and fine arts deserve the same modern ticketing. Valley Tickets does it all - for the whole district."
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-10">
        {FEATURES.map((f) => (
          <Card key={f.title} hover className="p-6">
            <div className="w-12 h-12 rounded-2xl bg-brand-50 flex items-center justify-center text-2xl mb-4">
              {f.icon}
            </div>
            <h3 className="text-lg font-bold font-display text-ink-900">{f.title}</h3>
            <p className="mt-2 text-ink-500 leading-relaxed">{f.desc}</p>
          </Card>
        ))}
      </div>
    </Container>
  </section>
);

export default FeatureGrid;
